
import { Store } from "redux";
import { RootState } from "../store/reducer"; // export type for component import
export type AppStoreType = Store;
export type AppStateType = RootState;

export function buildEvent(type: string, detail?: object) {
  return new CustomEvent(type, {
    bubbles: true,
    cancelable: true,
    detail: detail,
  });
}

export function getSizesForResponsiveImage(desktopPhotosPerRow: number, mobilePhotosPerRow: number, isHighlighted: boolean=false) {
  // TODO - add desktopItemPadding & mobileItemPadding into calculations
  let factor = 1;
  if (isHighlighted) { factor = 2; }

  const desktopImageSize = ((100 / (desktopPhotosPerRow / factor)) / 100).toString();
  const mobileImageSize = ((100 / (mobilePhotosPerRow / factor)) / 100).toString();

  // calculate individual image size on desktop & mobile
  // this tells browser which image to choose (standard vs. hi-res)
  // for eg. if we have: 4 Photos per row, size of individual image is: calc(0.25 * 100vw)
  // browser will calc() in pixels and then choose appropriate image
  return `(min-width: 800px) calc(${desktopImageSize} * 100vw), calc(${mobileImageSize} * 100vw)`;
}

/**
 * convert hex to RGBA color
 */
export function hexToRGBA(h, opacity) {
  let r = "0", g = "0", b = "0";

  // 3 digits
  if (h.length === 4) {
    r = "0x" + h[1] + h[1];
    g = "0x" + h[2] + h[2];
    b = "0x" + h[3] + h[3];

  // 6 digits
  } else if (h.length === 7) {
    r = "0x" + h[1] + h[2];
    g = "0x" + h[3] + h[4];
    b = "0x" + h[5] + h[6];
  }

  return "rgb("+ +r + "," + +g + "," + +b + "," +opacity+ ")";
}

/**
 * format Shopify product price
 */
export function formatMoney(cents, format, returnOnlyValue = false) {
  var value = "",
    placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
    placeholderRegexReplace = /\{\{\s*(\w+)\s*\}\}/g,
    formatString = (format || this.money_format);

  if (typeof cents === "string") {
    cents = cents.replace(".","");
  }

  function defaultOption(opt, def) {
    return (typeof opt === "undefined" ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal   = defaultOption(decimal, ".");

    if (isNaN(number) || number === null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? (decimal + parts[1]) : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
  case "amount":
    value = formatWithDelimiters(cents, 2, ",", ".");
    break;
  case "amount_no_decimals":
    value = formatWithDelimiters(cents, 0, ",", ".");
    break;
  case "amount_with_comma_separator":
    value = formatWithDelimiters(cents, 2, ".", ",");
    break;
  case "amount_no_decimals_with_comma_separator":
    value = formatWithDelimiters(cents, 0, ".", ",");
    break;
  }

  return returnOnlyValue ? value : formatString.replace(placeholderRegexReplace, value);
}

export function findSharedItemPopup(embedIdSource, galleryType) {
  const getLocationParam = (paramName: string) => {
    const params = window.location.search.replace("?", "").split("&");
    const param = params.find(el => el.startsWith(`${paramName}=`));
    if (param === undefined) return null;
    return param.replace(`${paramName}=`, "");
  };

  const itemId = getLocationParam("covet-pics-photo-id");
  const embedId = getLocationParam("covet-pics-embed-id");
  const isNeedToOpenPopup = itemId !== null && ((embedIdSource && embedIdSource === parseInt(embedId)) || galleryType === "product_gallery");

  return isNeedToOpenPopup ? itemId : null;
}

export function getCoverImage(coverImageUrl, imageUrl) {
  if (coverImageUrl !== undefined) {
    return coverImageUrl;
  } else {
    return imageUrl;
  }
}

export function sendToGoogleAnalytics(eventAction, eventCategory, eventLabel) {
  // console.log("sendToGoogleAnalytics");
  const ga = (window as any).ga;
  const gaq = (window as any)._gaq;
  const dl = (window as any).dataLayer;
  const isNonInteractiveEvent = (eventAction === "Covet.pics Gallery View");

  if (typeof dl !== "undefined") {
    dl.push({
      event: "covetPicsEvent",
      eventAction: eventAction,
      eventCategory: eventCategory,
      eventLabel: eventLabel,
      nonInteraction: isNonInteractiveEvent
    });
  } else if (typeof ga !== "undefined") {
    ga("send", {
      hitType: "event",
      eventCategory: eventCategory,
      eventAction: eventAction,
      eventLabel: eventLabel,
      nonInteraction: isNonInteractiveEvent
    });
  } else if (typeof gaq !== "undefined") {
    gaq.push(["_trackEvent", eventCategory, eventAction, eventLabel, undefined, isNonInteractiveEvent]);
  }

  return true;
}

export function getDateFromTimestamp(timestamp: string) {
  const time = new Date(timestamp);
  return `${time.getDate()}-${time.getMonth().toString()}-${time.getFullYear()}`;
}

export function getSize(el, property) {
  return el !== null
    ? el.getBoundingClientRect()[property]
    : 0;
}

export function getStyle(el, property) {
  return el !== null
    ? parseInt(window.getComputedStyle(el)[property].slice(0, -2))
    : 0;
}

export function getRandomId(size = 16) {
  const randomChar = () => Math.round(16 * Math.random()).toString(16);
  return "x".repeat(size).replace(/x/g, randomChar);
}

export const BASE_API_URLS = {
  "production": "https://app.covet.pics",
  "development": "http://localhost:3000",
  "staging": "https://covetstaging.spacesquirrel.net",
  "testing": "http://localhost:3000/testing_db"
};
